import {
  CLIENT_CODMETHODS_TYPES_REQUEST,
  CLIENT_CODMETHODS_TYPES_SUCCESS,
  CLIENT_CODMETHODS_TYPES_FAILURE,
  RESET_CODMETHODS_TYPES
} from '../../actions/clientCodActions'

export default function reducer(
  state = {
    isFetching: false,
    data: [],
    errors: {},
    needRefresh: false
  },
  action
) {
  switch (action.type) {
    case CLIENT_CODMETHODS_TYPES_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        needRefresh: false
      })

    case CLIENT_CODMETHODS_TYPES_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data
      })

    case CLIENT_CODMETHODS_TYPES_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errors: action.data
      })

    case RESET_CODMETHODS_TYPES:
      return Object.assign({}, state, {
        isFetching: false,
        needRefresh: false,
        data: [],
        errors: {}
      })

    default:
      return state
  }
}
